<template>
  <div class="query-box">
    <div class="row-head" style="line-height: 48px;">查询条件</div>
    <el-row class="row-border" style="padding: 10px;">
      <template v-for="(item,index) in groups">
        <div class="row-head" :key="'t' + index">{{index==0?"基础信息":item.ClassName}}</div>
        <div class="query-row" :key="'q' + index">
          <div class="part">{{item.LeftPart}}</div>
          <div class="item-row bl br" style="width:calc(100% - 60px);">
            <el-form class="row-content" label-width="100px" v-if="item.Dts.length" style="width:100%;">
              <el-form-item label="现任年级" v-if="findComponent(item,'BaseInfo_NowGradeIds')">
                <el-select
                  v-model="item.Dts[findSn(item,'BaseInfo_NowGradeIds')].Value1"
                  collapse-tags
                  clearable
                  multiple
                  placeholder="请选择现任年级"
                >
                  <template v-for="(i,key) in gradeList">
                    <el-option :key="key" :label="i.Grade" :value="i.GradeId"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="科目" v-if="findComponent(item,'BaseInfo_Subjects')">
                <el-select
                  v-model="item.Dts[findSn(item,'BaseInfo_Subjects')].Value1"
                  collapse-tags
                  clearable
                  multiple
                  placeholder="请选择科目"
                >
                  <template v-for="(i,key) in subjectList">
                    <el-option :key="key" :label="i.Subject" :value="i.Subject"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="姓名" v-if="findComponent(item,'BaseInfo_TeacherName')">
                <el-input
                  v-model="item.Dts[findSn(item,'BaseInfo_TeacherName')].Value1"
                  placeholder="请填写姓名"
                  clearable
                />
              </el-form-item>
              <el-form-item label="性别" v-if="findComponent(item,'BaseInfo_Sex')">
                <el-select v-model="item.Dts[findSn(item,'BaseInfo_Sex')].Value1" clearable placeholder="请选择性别">
                  <el-option label="无" :value="0"></el-option>
                  <el-option label="男" :value="1"></el-option>
                  <el-option label="女" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="入职年份" v-if="findComponent(item,'BaseInfo_InYear')">
                <el-select
                  v-model="item.Dts[findSn(item,'BaseInfo_InYear')].Value1"
                  clearable
                  placeholder="请选择入职年份"
                >
                  <template v-for="(i,key) in yearList">
                    <el-option :key="key" :label="i" :value="i"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="最高学历" v-if="findComponent(item,'BaseInfo_Edu')">
                <el-select v-model="item.Dts[findSn(item,'BaseInfo_Edu')].Value1" clearable placeholder="请选择最高学历">
                  <template v-for="(i,key) in zgxl">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="政治面貌" v-if="findComponent(item,'BaseInfo_Politics')">
                <el-select
                  v-model="item.Dts[findSn(item,'BaseInfo_Politics')].Value1"
                  clearable
                  placeholder="请选择政治面貌"
                >
                  <el-option label="党员" value="党员"></el-option>
                  <el-option label="非党员" value="非党员"></el-option>
                  <el-option label="民盟" value="民盟"></el-option>
                  <el-option label="民进" value="民进"></el-option>
                  <el-option label="农工" value="农工"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="兼任职务" v-if="findComponent(item,'BaseInfo_JobNames')">
                <el-select
                  v-model="item.Dts[findSn(item,'BaseInfo_JobNames')].Value1"
                  multiple
                  collapse-tags
                  clearable
                  placeholder="请选择职务"
                >
                  <template v-for="(i,key) in jobList">
                    <el-option :key="key" :label="i.JobName" :value="i.JobName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="职称" v-if="findComponent(item,'BaseInfo_Titles')">
                <el-select
                  v-model="item.Dts[findSn(item,'BaseInfo_Titles')].Value1"
                  multiple
                  collapse-tags
                  clearable
                  placeholder="请选择职称"
                >
                  <el-option label="未定级" value="未定级"></el-option>
                  <el-option label="二级" value="二级"></el-option>
                  <el-option label="一级" value="一级"></el-option>
                  <el-option label="高级" value="高级"></el-option>
                  <el-option label="正高级" value="正高级"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否完成支教" v-if="findComponent(item,'BaseInfo_HasSupport')">
                <el-select v-model="item.Dts[findSn(item,'BaseInfo_HasSupport')].Value1" clearable>
                  <el-option label="是" :value="true"></el-option>
                  <el-option label="否" :value="false"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="任现职称年限" v-if="findComponent(item,'BaseInfo_EvaluateYear')">
                <div style="display: flex;width: 210px;">
                  <el-input
                    v-model="item.Dts[findSn(item,'BaseInfo_EvaluateYear')].Value1"
                    v-int
                    clearable
                  />
                  <span style="margin: 0 5px;">-</span>
                  <el-input
                    v-model="item.Dts[findSn(item,'BaseInfo_EvaluateYear')].Value2"
                    v-int
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item label="德育总年限" v-if="findComponent(item,'BaseInfo_JobYear')">
                <div style="display: flex;width: 210px;">
                  <el-input
                    v-model="item.Dts[findSn(item,'BaseInfo_JobYear')].Value1"
                    v-int
                    clearable
                  />
                  <span style="margin: 0 5px;">-</span>
                  <el-input
                    v-model="item.Dts[findSn(item,'BaseInfo_JobYear')].Value2"
                    v-int
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item label="任现职德育总年限" v-if="findComponent(item,'BaseInfo_NowJobYear')">
                <div style="display: flex;width: 210px;">
                  <el-input
                    v-model="item.Dts[findSn(item,'BaseInfo_NowJobYear')].Value1"
                    v-int
                    clearable
                  />
                  <span style="margin: 0 5px;">-</span>
                  <el-input
                    v-model="item.Dts[findSn(item,'BaseInfo_NowJobYear')].Value2"
                    v-int
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item label="任现职是否完成大循环" v-if="findComponent(item,'BaseInfo_GradeCycle')">
                <el-select v-model="item.Dts[findSn(item,'BaseInfo_GradeCycle')].Value1" clearable>
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="任现职是否任高三3年以上" v-if="findComponent(item,'BaseInfo_Grade3More')">
                <el-select v-model="item.Dts[findSn(item,'BaseInfo_Grade3More')].Value1" clearable>
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="表彰名称" v-if="findComponent(item,'ClassAward_ClassAwardName')">
                <el-select
                  v-model="item.Dts[findSn(item,'ClassAward_ClassAwardName')].Value1"
                  clearable
                  placeholder="请选择表彰名称"
                >
                  <template v-for="(i,key) in sdbjbzmc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="表彰时间" v-if="findComponent(item,'ClassAward_GetDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'ClassAward_GetDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'ClassAward_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'ClassAward_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="等次" v-if="findComponent(item,'ClassAward_GdGrades')">
                <el-select
                  v-model="item.Dts[findSn(item,'ClassAward_GdGrades')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择等次"
                >
                  <template v-for="(i,key) in dc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="承担时间" v-if="findComponent(item,'Theme_BearDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'Theme_BearDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'Theme_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'Theme_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="荣誉名称" v-if="findComponent(item,'EduHoner_EduHonerName')">
                <el-select
                  v-model="item.Dts[findSn(item,'EduHoner_EduHonerName')].Value1"
                  clearable
                  placeholder="请选择荣誉名称"
                >
                  <template v-for="(i,key) in dylrymc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="获得时间" v-if="findComponent(item,'EduHoner_GetDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'EduHoner_GetDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'EduHoner_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'EduHoner_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <!-- //------------------------------- -->
              <el-form-item label="项目名称" v-if="findComponent(item,'EduAward_EduAwardName')">
                <el-select
                  v-model="item.Dts[findSn(item,'EduAward_EduAwardName')].Value1"
                  clearable
                  placeholder="请选择项目名称"
                >
                  <template v-for="(i,key) in dyljxmc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="获得时间" v-if="findComponent(item,'EduAward_GetDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'EduAward_GetDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'EduAward_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'EduAward_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="等次" v-if="findComponent(item,'EduAward_GdGrades')">
                <el-select
                  v-model="item.Dts[findSn(item,'EduAward_GdGrades')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择等次"
                >
                  <template v-for="(i,key) in dc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="承担时间" v-if="findComponent(item,'OpenClass_BearDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'OpenClass_BearDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'OpenClass_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'OpenClass_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="项目名称" v-if="findComponent(item,'Edu1Race_Edu1RaceName')">
                <el-select
                  v-model="item.Dts[findSn(item,'Edu1Race_Edu1RaceName')].Value1"
                  clearable
                  placeholder="请选择项目名称"
                >
                  <template v-for="(i,key) in jx1ljsjx">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="获得时间" v-if="findComponent(item,'Edu1Race_GetDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'Edu1Race_GetDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类型" v-if="findComponent(item,'Edu1Race_GdTypes')">
                <el-select
                  v-model="item.Dts[findSn(item,'Edu1Race_GdTypes')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类型"
                >
                  <template v-for="(i,key) in lx">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'Edu1Race_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'Edu1Race_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="等次" v-if="findComponent(item,'Edu1Race_GdGrades')">
                <el-select
                  v-model="item.Dts[findSn(item,'Edu1Race_GdGrades')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择等次"
                >
                  <template v-for="(i,key) in dc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="项目名称" v-if="findComponent(item,'Edu2Race_Edu2RaceName')">
                <el-select
                  v-model="item.Dts[findSn(item,'Edu2Race_Edu2RaceName')].Value1"
                  clearable
                  placeholder="请选择项目名称"
                >
                  <template v-for="(i,key) in jx2ljsjx">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="获得时间" v-if="findComponent(item,'Edu2Race_GetDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'Edu2Race_GetDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类型" v-if="findComponent(item,'Edu2Race_GdTypes')">
                <el-select
                  v-model="item.Dts[findSn(item,'Edu2Race_GdTypes')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类型"
                >
                  <template v-for="(i,key) in lx">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'Edu2Race_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'Edu2Race_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="等次" v-if="findComponent(item,'Edu2Race_GdGrades')">
                <el-select
                  v-model="item.Dts[findSn(item,'Edu2Race_GdGrades')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择等次"
                >
                  <template v-for="(i,key) in dc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="所属项目" v-if="findComponent(item,'TeachHoner_TeachHonerName')">
                <el-select
                  v-model="item.Dts[findSn(item,'TeachHoner_TeachHonerName')].Value1"
                  clearable
                  placeholder="请选择所属项目"
                >
                  <template v-for="(i,key) in jxlryssxm">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="获得时间" v-if="findComponent(item,'TeachHoner_GetDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'TeachHoner_GetDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'TeachHoner_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'TeachHoner_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="发表时间" v-if="findComponent(item,'Paper_PublishDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'Paper_PublishDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类别" v-if="findComponent(item,'Paper_GdCategorys')">
                <el-select
                  v-model="item.Dts[findSn(item,'Paper_GdCategorys')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类别"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'Paper_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'Paper_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="本人角色" v-if="findComponent(item,'Paper_Roles')">
                <el-select
                  v-model="item.Dts[findSn(item,'Paper_Roles')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择本人角色"
                >
                  <el-option label="独立撰写" value="独立撰写"></el-option>
                  <el-option label="第一作者" value="第一作者"></el-option>
                  <el-option label="第二作者" value="第二作者"></el-option>
                  <el-option label="其它" value="其它"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="立项时间" v-if="findComponent(item,'EduProject_ProjectDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'EduProject_ProjectDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="结题时间" v-if="findComponent(item,'EduProject_FinishDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'EduProject_FinishDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类别" v-if="findComponent(item,'EduProject_GdCategorys')">
                <el-select
                  v-model="item.Dts[findSn(item,'EduProject_GdCategorys')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类别"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'EduProject_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'EduProject_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="本人角色" v-if="findComponent(item,'EduProject_Roles')">
                <el-select
                  v-model="item.Dts[findSn(item,'EduProject_Roles')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择本人角色"
                >
                  <el-option label="主持人" value="主持人"></el-option>
                  <el-option label="主要参与者" value="主要参与者"></el-option>
                  <el-option label="参与者" value="参与者"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="出版时间" v-if="findComponent(item,'Book_PublishDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'Book_PublishDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类别" v-if="findComponent(item,'Book_GdCategorys')">
                <el-select
                  v-model="item.Dts[findSn(item,'Book_GdCategorys')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类别"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="本人撰写部分" v-if="findComponent(item,'Book_WriteParts')">
                <el-select
                  v-model="item.Dts[findSn(item,'Book_WriteParts')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择本人撰写部分"
                >
                  <template v-for="(i,key) in brzxbf">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="奖项名称" v-if="findComponent(item,'EduResult_EduResultName')">
                <el-input
                  v-model="item.Dts[findSn(item,'EduResult_EduResultName')].Value1"
                  placeholder="请填写奖项名称"
                  clearable
                />
              </el-form-item>
              <el-form-item label="获得时间" v-if="findComponent(item,'EduResult_GetDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'EduResult_GetDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类别" v-if="findComponent(item,'EduResult_GdCategorys')">
                <el-select
                  v-model="item.Dts[findSn(item,'EduResult_GdCategorys')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类别"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'EduResult_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'EduResult_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="等次" v-if="findComponent(item,'EduResult_GdGrades')">
                <el-select
                  v-model="item.Dts[findSn(item,'EduResult_GdGrades')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择等次"
                >
                  <template v-for="(i,key) in dc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="团体名称" v-if="findComponent(item,'Group_GroupName')">
                <el-select
                  v-model="item.Dts[findSn(item,'Group_GroupName')].Value1"
                  clearable
                  placeholder="请选择团体名称"
                >
                  <template v-for="(i,key) in ttmc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="加入时间"
                v-if="findComponent(item,'Group_JoinDate')"
              >
                <el-date-picker
                  v-model="item.Dts[findSn(item,'Group_JoinDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类别" v-if="findComponent(item,'Group_GdCategorys')">
                <el-select
                  v-model="item.Dts[findSn(item,'Group_GdCategorys')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类别"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'Group_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'Group_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="本人角色" v-if="findComponent(item,'Group_Roles')">
                <el-select
                  v-model="item.Dts[findSn(item,'Group_Roles')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择本人角色"
                >
                  <el-option label="主持人" value="主持人"></el-option>
                  <el-option label="主要参与者" value="主要参与者"></el-option>
                  <el-option label="参与者" value="参与者"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="项目名称" v-if="findComponent(item,'GuideTeacher_GuideTeacherName')">
                <el-select
                  v-model="item.Dts[findSn(item,'GuideTeacher_GuideTeacherName')].Value1"
                  clearable
                  placeholder="请选择项目名称"
                >
                  <template v-for="(i,key) in zdjsxmmc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="项目时间" v-if="findComponent(item,'GuideTeacher_ProjectDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'GuideTeacher_ProjectDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类别" v-if="findComponent(item,'GuideTeacher_GdCategorys')">
                <el-select
                  v-model="item.Dts[findSn(item,'GuideTeacher_GdCategorys')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类别"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'GuideTeacher_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'GuideTeacher_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="承担时间" v-if="findComponent(item,'Lecture_BearDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'Lecture_BearDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类别" v-if="findComponent(item,'Lecture_GdCategorys')">
                <el-select
                  v-model="item.Dts[findSn(item,'Lecture_GdCategorys')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类别"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'Lecture_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'Lecture_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="荣誉名称" v-if="findComponent(item,'ComHoner_ComHonerName')">
                <el-select
                  v-model="item.Dts[findSn(item,'ComHoner_ComHonerName')].Value1"
                  clearable
                  placeholder="请选择荣誉名称"
                >
                  <template v-for="(i,key) in zhxrymc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="获得时间" v-if="findComponent(item,'ComHoner_GetDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'ComHoner_GetDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'ComHoner_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'ComHoner_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="项目名称" v-if="findComponent(item,'GuideStudent_GuideStudentName')">
                <el-select
                  v-model="item.Dts[findSn(item,'GuideStudent_GuideStudentName')].Value1"
                  clearable
                  placeholder="请选择项目名称"
                >
                  <template v-for="(i,key) in zdxsxmmc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="项目时间" v-if="findComponent(item,'GuideStudent_ProjectDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'GuideStudent_ProjectDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类型" v-if="findComponent(item,'GuideStudent_GdCategorys')">
                <el-select
                  v-model="item.Dts[findSn(item,'GuideStudent_GdCategorys')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类型"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'GuideStudent_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'GuideStudent_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="活动主题" v-if="findComponent(item,'Train_Theme')">
                <el-select
                  v-model="item.Dts[findSn(item,'Train_Theme')].Value1"
                  clearable
                  placeholder="请选择活动主题"
                >
                  <template v-for="(i,key) in pxhdzt">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="项目名称" v-if="findComponent(item,'Train_TrainName')">
                <el-select
                  v-model="item.Dts[findSn(item,'Train_TrainName')].Value1"
                  clearable
                  placeholder="请选择项目名称"
                >
                  <template v-for="(i,key) in xxpxxmmc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="项目时间" v-if="findComponent(item,'Train_ProjectDate')">
                <el-date-picker
                  v-model="item.Dts[findSn(item,'Train_ProjectDate')].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类型" v-if="findComponent(item,'Train_GdTypes')">
                <el-select
                  v-model="item.Dts[findSn(item,'Train_GdTypes')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类型"
                >
                  <template v-for="(i,key) in pxlx">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="findComponent(item,'Train_GdLvs')">
                <el-select
                  v-model="item.Dts[findSn(item,'Train_GdLvs')].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <!-- //------------------- -->
            </el-form>
          </div>
          <div class="part">{{item.RightPart}} {{item.ConditionOperator}}</div>
        </div>
      </template>
    </el-row>
    <!-- <el-row class="row-border" style="padding: 10px;">
      <template v-if="showTitle('基本信息')">
        <div class="row-head">基本信息</div>
        <div class="query-row">
          <div class="item-row">
            <div class="row-title">基础信息</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item label="现任年级" v-if="Query['BaseInfo_NowGradeIds'].Checked">
                <el-select
                  v-model="Query['BaseInfo_NowGradeIds'].Value1"
                  collapse-tags
                  clearable
                  multiple
                  placeholder="请选择现任年级"
                >
                  <template v-for="(i,key) in gradeList">
                    <el-option :key="key" :label="i.Grade" :value="i.GradeId"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="科目" v-if="Query['BaseInfo_Subjects'].Checked">
                <el-select
                  v-model="Query['BaseInfo_Subjects'].Value1"
                  collapse-tags
                  clearable
                  multiple
                  placeholder="请选择科目"
                >
                  <template v-for="(i,key) in subjectList">
                    <el-option :key="key" :label="i.Subject" :value="i.Subject"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="姓名" v-if="Query['BaseInfo_TeacherName'].Checked">
                <el-input
                  v-model="Query['BaseInfo_TeacherName'].Value1"
                  placeholder="请填写姓名"
                  clearable
                />
              </el-form-item>
              <el-form-item label="性别" v-if="Query['BaseInfo_Sex'].Checked">
                <el-select v-model="Query['BaseInfo_Sex'].Value1" clearable placeholder="请选择性别">
                  <el-option label="无" :value="0"></el-option>
                  <el-option label="男" :value="1"></el-option>
                  <el-option label="女" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="入职年份" v-if="Query['BaseInfo_InYear'].Checked">
                <el-select
                  v-model="Query['BaseInfo_InYear'].Value1"
                  clearable
                  placeholder="请选择入职年份"
                >
                  <template v-for="(i,key) in yearList">
                    <el-option :key="key" :label="i" :value="i"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="最高学历" v-if="Query['BaseInfo_Edu'].Checked">
                <el-select v-model="Query['BaseInfo_Edu'].Value1" clearable placeholder="请选择最高学历">
                  <template v-for="(i,key) in zgxl">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="政治面貌" v-if="Query['BaseInfo_Politics'].Checked">
                <el-select
                  v-model="Query['BaseInfo_Politics'].Value1"
                  clearable
                  placeholder="请选择政治面貌"
                >
                  <el-option label="党员" value="党员"></el-option>
                  <el-option label="非党员" value="非党员"></el-option>
                  <el-option label="民盟" value="民盟"></el-option>
                  <el-option label="民进" value="民进"></el-option>
                  <el-option label="农工" value="农工"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="兼任职务" v-if="Query['BaseInfo_JobNames'].Checked">
                <el-select
                  v-model="Query['BaseInfo_JobNames'].Value1"
                  multiple
                  collapse-tags
                  clearable
                  placeholder="请选择职务"
                >
                  <template v-for="(i,key) in jobList">
                    <el-option :key="key" :label="i.JobName" :value="i.JobName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="职称" v-if="Query['BaseInfo_Titles'].Checked">
                <el-select
                  v-model="Query['BaseInfo_Titles'].Value1"
                  multiple
                  collapse-tags
                  clearable
                  placeholder="请选择职称"
                >
                  <el-option label="未定级" value="未定级"></el-option>
                  <el-option label="二级" value="二级"></el-option>
                  <el-option label="一级" value="一级"></el-option>
                  <el-option label="高级" value="高级"></el-option>
                  <el-option label="正高级" value="正高级"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否完成支教" v-if="Query['BaseInfo_HasSupport'].Checked">
                <el-select v-model="Query['BaseInfo_HasSupport'].Value1" clearable>
                  <el-option label="是" :value="true"></el-option>
                  <el-option label="否" :value="false"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="任现职称年限"
                v-if="Query['BaseInfo_EvaluateStartYear,BaseInfo_EvaluateEndYear'].Checked"
              >
                <div style="display: flex;width: 210px;">
                  <el-input
                    v-model="Query['BaseInfo_EvaluateStartYear,BaseInfo_EvaluateEndYear'].Value1"
                    v-int
                    clearable
                  />
                  <span style="margin: 0 5px;">-</span>
                  <el-input
                    v-model="Query['BaseInfo_EvaluateStartYear,BaseInfo_EvaluateEndYear'].Value2"
                    v-int
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item
                label="德育总年限"
                v-if="Query['BaseInfo_JobStartYear,BaseInfo_JobEndYear'].Checked"
              >
                <div style="display: flex;width: 210px;">
                  <el-input
                    v-model="Query['BaseInfo_JobStartYear,BaseInfo_JobEndYear'].Value1"
                    v-int
                    clearable
                  />
                  <span style="margin: 0 5px;">-</span>
                  <el-input
                    v-model="Query['BaseInfo_JobStartYear,BaseInfo_JobEndYear'].Value2"
                    v-int
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item
                label="任现职德育总年限"
                v-if="Query['BaseInfo_NowJobStartYear,BaseInfo_NowJobEndYear'].Checked"
              >
                <div style="display: flex;width: 210px;">
                  <el-input
                    v-model="Query['BaseInfo_NowJobStartYear,BaseInfo_NowJobEndYear'].Value1"
                    v-int
                    clearable
                  />
                  <span style="margin: 0 5px;">-</span>
                  <el-input
                    v-model="Query['BaseInfo_NowJobStartYear,BaseInfo_NowJobEndYear'].Value2"
                    v-int
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item label="任现职是否完成大循环" v-if="Query['BaseInfo_GradeCycle'].Checked">
                <el-select v-model="Query['BaseInfo_GradeCycle'].Value1" clearable>
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="任现职是否任高三3年以上" v-if="Query['BaseInfo_Grade3More'].Checked">
                <el-select v-model="Query['BaseInfo_Grade3More'].Value1" clearable>
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
      <template v-if="showTitle('育人工作')">
        <div class="row-head">育人工作</div>
        <div class="query-row">
          <div class="item-row" v-if="showSubTitle('Theme')">
            <div class="row-title">主题班会</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item
                label="承担时间"
                v-if="Query['Theme_BearStartDate,Theme_BearEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['Theme_BearStartDate,Theme_BearEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="级别" v-if="Query['Theme_GdLvs'].Checked">
                <el-select
                  v-model="Query['Theme_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="item-row" v-if="showSubTitle('EduHoner')">
            <div class="row-title">个人德育类荣誉</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item label="荣誉名称" v-if="Query['EduHoner_EduHonerName'].Checked">
                <el-select
                  v-model="Query['EduHoner_EduHonerName'].Value1"
                  clearable
                  placeholder="请选择荣誉名称"
                >
                  <template v-for="(i,key) in dylrymc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="获得时间"
                v-if="Query['EduHoner_GetStartDate,EduHoner_GetEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['EduHoner_GetStartDate,EduHoner_GetEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="级别" v-if="Query['EduHoner_GdLvs'].Checked">
                <el-select
                  v-model="Query['EduHoner_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="item-row" v-if="showSubTitle('EduAward')">
            <div class="row-title">个人德育类奖项</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item label="项目名称" v-if="Query['EduAward_EduAwardName'].Checked">
                <el-select
                  v-model="Query['EduAward_EduAwardName'].Value1"
                  clearable
                  placeholder="请选择项目名称"
                >
                  <template v-for="(i,key) in dyljxmc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="获得时间"
                v-if="Query['EduAward_GetStartDate,EduAward_GetEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['EduAward_GetStartDate,EduAward_GetEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="级别" v-if="Query['EduAward_GdLvs'].Checked">
                <el-select
                  v-model="Query['EduAward_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="等次" v-if="Query['EduAward_GdGrades'].Checked">
                <el-select
                  v-model="Query['EduAward_GdGrades'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择等次"
                >
                  <template v-for="(i,key) in dc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="item-row" v-if="showSubTitle('ClassAward')">
            <div class="row-title">所带班级表彰获奖</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item label="表彰名称" v-if="Query['ClassAward_ClassAwardName'].Checked">
                <el-select
                  v-model="Query['ClassAward_ClassAwardName'].Value1"
                  clearable
                  placeholder="请选择表彰名称"
                >
                  <template v-for="(i,key) in sdbjbzmc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="表彰时间"
                v-if="Query['ClassAward_GetStartDate,ClassAward_GetEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['ClassAward_GetStartDate,ClassAward_GetEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="级别" v-if="Query['ClassAward_GdLvs'].Checked">
                <el-select
                  v-model="Query['ClassAward_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="等次" v-if="Query['ClassAward_GdGrades'].Checked">
                <el-select
                  v-model="Query['ClassAward_GdGrades'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择等次"
                >
                  <template v-for="(i,key) in dc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
      <template v-if="showTitle('课程教学')">
        <div class="row-head">课程教学</div>
        <div class="query-row">
          <div class="item-row" v-if="showSubTitle('OpenClass')">
            <div class="row-title">公开课</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item
                label="承担时间"
                v-if="Query['OpenClass_BearStartDate,OpenClass_BearEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['OpenClass_BearStartDate,OpenClass_BearEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="级别" v-if="Query['OpenClass_GdLvs'].Checked">
                <el-select
                  v-model="Query['OpenClass_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="item-row" v-if="showSubTitle('Edu1Race')">
            <div class="row-title">教学1类竞赛获奖</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item label="项目名称" v-if="Query['Edu1Race_Edu1RaceName'].Checked">
                <el-select
                  v-model="Query['Edu1Race_Edu1RaceName'].Value1"
                  clearable
                  placeholder="请选择项目名称"
                >
                  <template v-for="(i,key) in jx1ljsjx">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="获得时间"
                v-if="Query['Edu1Race_GetStartDate,Edu1Race_GetEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['Edu1Race_GetStartDate,Edu1Race_GetEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类型" v-if="Query['Edu1Race_GdTypes'].Checked">
                <el-select
                  v-model="Query['Edu1Race_GdTypes'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类型"
                >
                  <template v-for="(i,key) in lx">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="Query['Edu1Race_GdLvs'].Checked">
                <el-select
                  v-model="Query['Edu1Race_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="等次" v-if="Query['Edu1Race_GdGrades'].Checked">
                <el-select
                  v-model="Query['Edu1Race_GdGrades'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择等次"
                >
                  <template v-for="(i,key) in dc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="item-row" v-if="showSubTitle('Edu2Race')">
            <div class="row-title">教学2类竞赛获奖</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item label="项目名称" v-if="Query['Edu2Race_Edu2RaceName'].Checked">
                <el-select
                  v-model="Query['Edu2Race_Edu2RaceName'].Value1"
                  clearable
                  placeholder="请选择项目名称"
                >
                  <template v-for="(i,key) in jx2ljsjx">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="获得时间"
                v-if="Query['Edu2Race_GetStartDate,Edu2Race_GetEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['Edu2Race_GetStartDate,Edu2Race_GetEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类型" v-if="Query['Edu2Race_GdTypes'].Checked">
                <el-select
                  v-model="Query['Edu2Race_GdTypes'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类型"
                >
                  <template v-for="(i,key) in lx">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="Query['Edu2Race_GdLvs'].Checked">
                <el-select
                  v-model="Query['Edu2Race_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="等次" v-if="Query['Edu2Race_GdGrades'].Checked">
                <el-select
                  v-model="Query['Edu2Race_GdGrades'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择等次"
                >
                  <template v-for="(i,key) in dc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="item-row" v-if="showSubTitle('TeachHoner')">
            <div class="row-title">教学类荣誉</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item label="所属项目" v-if="Query['TeachHoner_TeachHonerName'].Checked">
                <el-select
                  v-model="Query['TeachHoner_TeachHonerName'].Value1"
                  clearable
                  placeholder="请选择所属项目"
                >
                  <template v-for="(i,key) in jxlryssxm">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="获得时间"
                v-if="Query['TeachHoner_GetStartDate,TeachHoner_GetEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['TeachHoner_GetStartDate,TeachHoner_GetEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="级别" v-if="Query['TeachHoner_GdLvs'].Checked">
                <el-select
                  v-model="Query['TeachHoner_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
      <template v-if="showTitle('教科研')">
        <div class="row-head">教科研</div>
        <div class="query-row">
          <div class="item-row" v-if="showSubTitle('Paper')">
            <div class="row-title">论文发表</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item
                label="发表时间"
                v-if="Query['Paper_PublishStartDate,Paper_PublishEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['Paper_PublishStartDate,Paper_PublishEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类别" v-if="Query['Paper_GdCategorys'].Checked">
                <el-select
                  v-model="Query['Paper_GdCategorys'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类别"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="Query['Paper_GdLvs'].Checked">
                <el-select
                  v-model="Query['Paper_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="本人角色" v-if="Query['Paper_Roles'].Checked">
                <el-select
                  v-model="Query['Paper_Roles'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择本人角色"
                >
                  <el-option label="独立撰写" value="独立撰写"></el-option>
                  <el-option label="第一作者" value="第一作者"></el-option>
                  <el-option label="第二作者" value="第二作者"></el-option>
                  <el-option label="其它" value="其它"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="item-row" v-if="showSubTitle('EduProject')">
            <div class="row-title">教科研项目</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item
                label="立项时间"
                v-if="Query['EduProject_ProjectStartDate,EduProject_ProjectEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['EduProject_ProjectStartDate,EduProject_ProjectEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item
                label="结题时间"
                v-if="Query['EduProject_FinishStartDate,EduProject_FinishEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['EduProject_FinishStartDate,EduProject_FinishEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类别" v-if="Query['EduProject_GdCategorys'].Checked">
                <el-select
                  v-model="Query['EduProject_GdCategorys'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类别"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="Query['EduProject_GdLvs'].Checked">
                <el-select
                  v-model="Query['EduProject_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="本人角色" v-if="Query['EduProject_Roles'].Checked">
                <el-select
                  v-model="Query['EduProject_Roles'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择本人角色"
                >
                  <el-option label="主持人" value="主持人"></el-option>
                  <el-option label="主要参与者" value="主要参与者"></el-option>
                  <el-option label="参与者" value="参与者"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="item-row" v-if="showSubTitle('Book')">
            <div class="row-title">著作出版</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item
                label="出版时间"
                v-if="Query['Book_PublishStartDate,Book_PublishEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['Book_PublishStartDate,Book_PublishEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类别" v-if="Query['Book_GdCategorys'].Checked">
                <el-select
                  v-model="Query['Book_GdCategorys'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类别"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="本人撰写部分" v-if="Query['Book_WriteParts'].Checked">
                <el-select
                  v-model="Query['Book_WriteParts'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择本人撰写部分"
                >
                  <template v-for="(i,key) in brzxbf">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="item-row" v-if="showSubTitle('EduResult')">
            <div class="row-title">教育教学科研成果</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item label="奖项名称" v-if="Query['EduResult_EduResultName'].Checked">
                <el-input
                  v-model="Query['EduResult_EduResultName'].Value1"
                  placeholder="请填写奖项名称"
                  clearable
                />
              </el-form-item>
              <el-form-item
                label="获得时间"
                v-if="Query['EduResult_GetStartDate,EduResult_GetEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['EduResult_GetStartDate,EduResult_GetEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类别" v-if="Query['EduResult_GdCategorys'].Checked">
                <el-select
                  v-model="Query['EduResult_GdCategorys'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类别"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="Query['EduResult_GdLvs'].Checked">
                <el-select
                  v-model="Query['EduResult_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="等次" v-if="Query['EduResult_GdGrades'].Checked">
                <el-select
                  v-model="Query['EduResult_GdGrades'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择等次"
                >
                  <template v-for="(i,key) in dc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
      <template v-if="showTitle('示范引领')">
        <div class="row-head">示范引领</div>
        <div class="query-row">
          <div class="item-row" v-if="showSubTitle('Group')">
            <div class="row-title">参加学术团体</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item label="团体名称" v-if="Query['Group_GroupName'].Checked">
                <el-select
                  v-model="Query['Group_GroupName'].Value1"
                  clearable
                  placeholder="请选择团体名称"
                >
                  <template v-for="(i,key) in ttmc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="加入时间"
                v-if="Query['Group_JoinStartDate,Group_JoinEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['Group_JoinStartDate,Group_JoinEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类别" v-if="Query['Group_GdCategorys'].Checked">
                <el-select
                  v-model="Query['Group_GdCategorys'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类别"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="Query['Group_GdLvs'].Checked">
                <el-select
                  v-model="Query['Group_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="本人角色" v-if="Query['Group_Roles'].Checked">
                <el-select
                  v-model="Query['Group_Roles'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择本人角色"
                >
                  <el-option label="主持人" value="主持人"></el-option>
                  <el-option label="主要参与者" value="主要参与者"></el-option>
                  <el-option label="参与者" value="参与者"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="item-row" v-if="showSubTitle('GuideTeacher')">
            <div class="row-title">指导教师</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item label="项目名称" v-if="Query['GuideTeacher_GuideTeacherName'].Checked">
                <el-select
                  v-model="Query['GuideTeacher_GuideTeacherName'].Value1"
                  clearable
                  placeholder="请选择项目名称"
                >
                  <template v-for="(i,key) in zdjsxmmc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="项目时间"
                v-if="Query['GuideTeacher_ProjectStartDate,GuideTeacher_ProjectEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['GuideTeacher_ProjectStartDate,GuideTeacher_ProjectEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类别" v-if="Query['GuideTeacher_GdCategorys'].Checked">
                <el-select
                  v-model="Query['GuideTeacher_GdCategorys'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类别"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="Query['GuideTeacher_GdLvs'].Checked">
                <el-select
                  v-model="Query['GuideTeacher_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="item-row" v-if="showSubTitle('Lecture')">
            <div class="row-title">专题讲座</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item
                label="承担时间"
                v-if="Query['Lecture_BearStartDate,Lecture_BearEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['Lecture_BearStartDate,Lecture_BearEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类别" v-if="Query['Lecture_GdCategorys'].Checked">
                <el-select
                  v-model="Query['Lecture_GdCategorys'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类别"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="Query['Lecture_GdLvs'].Checked">
                <el-select
                  v-model="Query['Lecture_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="item-row" v-if="showSubTitle('ComHoner')">
            <div class="row-title">综合性荣誉称号</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item label="荣誉名称" v-if="Query['ComHoner_ComHonerName'].Checked">
                <el-select
                  v-model="Query['ComHoner_ComHonerName'].Value1"
                  clearable
                  placeholder="请选择荣誉名称"
                >
                  <template v-for="(i,key) in zhxrymc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="获得时间"
                v-if="Query['ComHoner_GetStartDate,ComHoner_GetEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['ComHoner_GetStartDate,ComHoner_GetEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="级别" v-if="Query['ComHoner_GdLvs'].Checked">
                <el-select
                  v-model="Query['ComHoner_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
      <template v-if="showTitle('指导学生')">
        <div class="row-head">指导学生</div>
        <div class="query-row">
          <div class="item-row">
            <div class="row-title">指导学生</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item label="项目名称" v-if="Query['GuideStudent_GuideStudentName'].Checked">
                <el-select
                  v-model="Query['GuideStudent_GuideStudentName'].Value1"
                  clearable
                  placeholder="请选择项目名称"
                >
                  <template v-for="(i,key) in zdxsxmmc">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="项目时间"
                v-if="Query['GuideStudent_ProjectStartDate,GuideStudent_ProjectEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['GuideStudent_ProjectStartDate,GuideStudent_ProjectEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类型" v-if="Query['GuideStudent_GdCategorys'].Checked">
                <el-select
                  v-model="Query['GuideStudent_GdCategorys'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类型"
                >
                  <template v-for="(i,key) in lb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="Query['GuideStudent_GdLvs'].Checked">
                <el-select
                  v-model="Query['GuideStudent_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
      <template v-if="showTitle('学习培训')">
        <div class="row-head">学习培训</div>
        <div class="query-row">
          <div class="item-row">
            <div class="row-title">学习培训</div>
            <el-form class="row-content" label-width="100px">
              <el-form-item label="活动主题" v-if="Query['Train_Theme'].Checked">
                <el-select
                  v-model="Query['Train_Theme'].Value1"
                  clearable
                  placeholder="请选择活动主题"
                >
                  <template v-for="(i,key) in pxhdzt">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="活动时间"
                v-if="Query['Train_ProjectStartDate,Train_ProjectEndDate'].Checked"
              >
                <el-date-picker
                  v-model="Query['Train_ProjectStartDate,Train_ProjectEndDate'].Value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
              <el-form-item label="类型" v-if="Query['Train_GdTypes'].Checked">
                <el-select
                  v-model="Query['Train_GdTypes'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择类型"
                >
                  <template v-for="(i,key) in pxlx">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="级别" v-if="Query['Train_GdLvs'].Checked">
                <el-select
                  v-model="Query['Train_GdLvs'].Value1"
                  collapse-tags
                  multiple
                  clearable
                  placeholder="请选择级别"
                >
                  <template v-for="(i,key) in jb">
                    <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
    </el-row> -->
  </div>
</template>
<script>
const combi = [
  { org: "BaseInfo_EvaluateYear", name1: "BaseInfo_EvaluateStartYear", name2: "BaseInfo_EvaluateEndYear" },
  { org: "BaseInfo_JobYear", name1: "BaseInfo_JobStartYear", name2: "BaseInfo_JobEndYear" },
  { org: "BaseInfo_NowJobYear", name1: "BaseInfo_NowJobStartYear", name2: "BaseInfo_NowJobEndYear" },
  { org: "Theme_BearDate", name1: "Theme_BearStartDate", name2: "Theme_BearEndDate" },
  { org: "EduHoner_GetDate", name1: "EduHoner_GetStartDate", name2: "EduHoner_GetEndDate" },
  { org: "EduAward_GetDate", name1: "EduAward_GetStartDate", name2: "EduAward_GetEndDate" },
  { org: "ClassAward_GetDate", name1: "ClassAward_GetStartDate", name2: "ClassAward_GetEndDate" },
  { org: "OpenClass_BearDate", name1: "OpenClass_BearStartDate", name2: "OpenClass_BearEndDate" },
  { org: "Edu1Race_GetDate", name1: "Edu1Race_GetStartDate", name2: "Edu1Race_GetEndDate" },
  { org: "Edu2Race_GetDate", name1: "Edu2Race_GetStartDate", name2: "Edu2Race_GetEndDate" },
  { org: "TeachHoner_GetDate", name1: "TeachHoner_GetStartDate", name2: "TeachHoner_GetEndDate" },
  { org: "Paper_PublishDate", name1: "Paper_PublishStartDate", name2: "Paper_PublishEndDate" },
  { org: "EduProject_ProjectDate", name1: "EduProject_ProjectStartDate", name2: "EduProject_ProjectEndDate" },
  { org: "EduProject_FinishDate", name1: "EduProject_FinishStartDate", name2: "EduProject_FinishEndDate" },
  { org: "Book_PublishDate", name1: "Book_PublishStartDate", name2: "Book_PublishEndDate" },
  { org: "EduResult_GetDate", name1: "EduResult_GetStartDate", name2: "EduResult_GetEndDate" },
  { org: "Group_JoinDate", name1: "Group_JoinStartDate", name2: "Group_JoinEndDate" },
  { org: "GuideTeacher_ProjectDate", name1: "GuideTeacher_ProjectStartDate", name2: "GuideTeacher_ProjectEndDate" },
  { org: "Lecture_BearDate", name1: "Lecture_BearStartDate", name2: "Lecture_BearEndDate" },
  { org: "ComHoner_GetDate", name1: "ComHoner_GetStartDate", name2: "ComHoner_GetEndDate" },
  { org: "GuideStudent_ProjectDate", name1: "GuideStudent_ProjectStartDate", name2: "GuideStudent_ProjectEndDate" },
  { org: "Train_ProjectDate", name1: "Train_ProjectStartDate", name2: "Train_ProjectEndDate" },
];
export default {
  data() {
    return {
      //QueryItem
      Titles: [],
      main: {},
      groups: [],
      Query: JSON.parse(JSON.stringify(require("./queryItems2.json"))),
      active: ["1"],
      yearList: [], //年份
      gradeList: [], //年级
      jobList: [], //职务
      subjectList: [], //科目
      lx: [], //类型
      pxlx: [], //培训类型
      jb: [], //级别
      hdjb: [], //活动级别
      dc: [], //等次
      lb: [], //类别
      zgxl: [], //最高学历
      dylrymc: [], //德育类荣誉名称
      dyljxmc: [], //德育类奖项名称
      dylbzmc: [], //德育类表彰名称
      sdbjbzmc: [], //所带班级表彰名称
      ttmc: [], //团体名称
      pxhdzt: [], //培训活动主题
      brzxbf: [], //本人撰写部分
      zhxrymc: [], //综合性荣誉名称
      jx1ljsjx: [], //教学1类竞赛奖项名称
      jx2ljsjx: [], //教学2类竞赛奖项名称
      jxlryssxm: [], //教学类荣誉所属项目
      zdjsxmmc: [], //指导教师项目名称
      zdxsxmmc: [], //指导学生项目名称
      xxpxxmmc: [], //学习培训项目名称
      grade_api: require("@/api/ed/grade").default,
      job_api: require("@/api/ent/job").default,
      subject_api: require("@/api/ed/subject").default,
      base_api: require("@/api/gd/basedata").default,
    };
  },
  methods: {
    setData(data) {
      this.getOptions();
      this.Titles = [];
      this.Query = JSON.parse(JSON.stringify(require("./queryItems2.json")));
      data.Groups.forEach(m => {
        m.T = 1;
        // m.del = [];
        // m.Dts.forEach(e => {
        //   m.del.push({ ...e, T: 2});
        // })
        m.Dts.forEach(n => {
          n.T = 1;
          n.ov = n.ApiParamValue;
          var pt = this.Query[n.ApiParamName].ParamType;
          switch (pt) {
            case "Array":
              if(n.ApiParamValue) {
                var arr = n.ApiParamValue.split(",");
                n.Value1 = arr.map(x => { return x>0?Number(x):x });
              } else {
                n.Value1 = [];
              }
              n.Value2 = null;
              break;
            case "Date":
              if(n.ApiParamValue) {
                n.Value1 = n.ApiParamValue.split(",");
              } else {
                n.Value1 = [];
              }
              n.Value2 = null;
              break;
            case "Interval":
              if(n.ApiParamValue) {
                n.Value1 = n.ApiParamValue.split(",")[0];
                n.Value2 = n.ApiParamValue.split(",")[1];
              } else {
                n.Value1 = null;
                n.Value2 = null;
              }
              break;
            case "Bool":
              if(n.ApiParamValue === "0") {
                n.Value1 = false;
              } else if(n.ApiParamValue === "1") {
                n.Value1 = true;
              } else {
                n.Value1 = null;
              }
              n.Value2 = null;
              break;
            case "Num":
              if(n.ApiParamValue) {
                n.Value1 = Number(n.ApiParamValue);
              } else {
                n.Value1 = null;
              }
              n.Value2 = null;
              break;
            default:
              n.Value1 = n.ApiParamValue;
              n.Value2 = null;
              break;
          }
        })
      });
      this.$nextTick(() => {
        this.main = data;
        this.groups = data.Groups;
      })
    },
    getData() {
      var sub = [];
      var gg = [];
      this.groups.forEach(e => {
        var Param = {};
        e.Dts.forEach(m => {
          var obj = combi.find(x => x.org == m.ApiParamName);
          var pt = this.Query[m.ApiParamName].ParamType;
          if(obj) {
            switch (pt) {
              case "Date":
                if(m.Value1 && m.Value1.length) {
                  m.ApiParamValue = m.Value1.join(",");
                  Param[obj.name1] = m.Value1[0];
                  Param[obj.name2] = m.Value1[1];
                } else {
                  m.ApiParamValue = "";
                }
                break;
              case "Interval":
                if(m.Value1 || m.Value1 === 0) {
                  m.ApiParamValue = m.Value1;
                  Param[obj.name1] = m.Value1;
                } else {
                  m.ApiParamValue = "";
                }
                if(m.Value2 || m.Value2 === 0) {
                  m.ApiParamValue += "," + m.Value2;
                  Param[obj.name2] = m.Value2;
                }
                break;
            }
          } else {
            switch (pt) {
              case "Array":
                if(m.Value1.length) {
                  m.ApiParamValue = m.Value1.join(",");
                  Param[m.ApiParamName] = m.Value1;
                } else {
                  m.ApiParamValue = "";
                }
                break;
              case "Bool":
                if(m.Value1 === true) {
                  m.ApiParamValue = "1";
                } else if(m.Value1 === false) {
                  m.ApiParamValue = "0";
                } else {
                  m.ApiParamValue = "";
                }
                Param[m.ApiParamName] = m.Value1;
                break;
              case "Num":
                if(m.Value1 || m.Value1 === 0) {
                  m.ApiParamValue = String(m.Value1);
                  Param[m.ApiParamName] = m.Value1;
                }
                break;
              case "String":
                if(m.Value1) {
                  m.ApiParamValue = String(m.Value1);
                  Param[m.ApiParamName] = String(m.Value1);
                } else {
                  m.ApiParamValue = "";
                }
                break;
              default:
                if(m.Value1) {
                  m.ApiParamValue = m.Value1;
                  Param[m.ApiParamName] = m.Value1;
                } else {
                  m.ApiParamValue = "";
                }
                break;
            }
          }
        })
        sub.push({
          Param,
          QueryGroupId: e.QueryGroupId,
          QueryPlanId: e.QueryPlanId,
          LeftPart: e.LeftPart,
          ClassName: e.ClassName,
          RightPart: e.RightPart,
          ConditionOperator: e.ConditionOperator,
          Sn: e.Sn
        })
        gg.push({ ...e });
      })
      var place = [];
      gg.forEach(e => {
        var obj = { ...e, Dts: [] };
        for (let i = 0; i < e.Dts.length; i++) {
          var item = e.Dts[i];
          if(!(item.ov === item.ApiParamValue)) {
            obj.Dts.push({
              ApiParamName: item.ApiParamName,
              ApiParamValue: item.ApiParamValue,
              DtsName: item.DtsName,
              QueryGroupDtsId: item.QueryGroupDtsId,
              QueryGroupId: item.QueryGroupId,
              QueryPlanId: item.QueryPlanId,
              T: item.T
            });
          }
        }
        if(obj.Dts.length > 0) place.push(obj);
      })
      var main = { ...this.main, Groups: place };
      return { data: main, sub };
    },
    clear() {
      this.getOptions();
      this.Titles = [];
      this.Query = JSON.parse(JSON.stringify(require("./queryItems2.json")));
    },
    getOptions() {
      var date = new Date();
      this.yearList.push(1900);
      for (let i = 1900; i <= date.getFullYear(); i++) {
        this.yearList.push(i);
      }
      this.yearList.reverse();
      this.grade_api.list({}).then((res) => {
        this.gradeList = res.Data;
      });
      this.job_api.list({}).then((res) => {
        this.jobList = res.Data;
      });
      this.subject_api.list({}).then((res) => {
        this.subjectList = res.Data;
      });
      this.base_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) {
          this.lx = res.Data.filter((x) => x.ClassName == "类型");
          this.pxlx = res.Data.filter((x) => x.ClassName == "培训类型");
          this.jb = res.Data.filter((x) => x.ClassName == "级别");
          this.hdjb = res.Data.filter((x) => x.ClassName == "活动级别");
          this.dc = res.Data.filter((x) => x.ClassName == "等次");
          this.zgxl = res.Data.filter((x) => x.ClassName == "最高学历");
          this.dylrymc = res.Data.filter(
            (x) => x.ClassName == "德育类荣誉名称"
          );
          this.dyljxmc = res.Data.filter(
            (x) => x.ClassName == "德育类奖项名称"
          );
          this.dylbzmc = res.Data.filter(
            (x) => x.ClassName == "德育类表彰名称"
          );
          this.sdbjbzmc = res.Data.filter(
            (x) => x.ClassName == "所带班级表彰名称"
          );
          this.ttmc = res.Data.filter((x) => x.ClassName == "团体名称");
          this.pxhdzt = res.Data.filter((x) => x.ClassName == "培训活动主题");
          this.lb = res.Data.filter((x) => x.ClassName == "类别");
          this.brzxbf = res.Data.filter((x) => x.ClassName == "本人撰写部分");
          this.zhxrymc = res.Data.filter(
            (x) => x.ClassName == "综合性荣誉名称"
          );
          this.jx1ljsjx = res.Data.filter(
            (x) => x.ClassName == "教学1类竞赛奖项名称"
          );
          this.jx2ljsjx = res.Data.filter(
            (x) => x.ClassName == "教学2类竞赛奖项名称"
          );
          this.jxlryssxm = res.Data.filter(
            (x) => x.ClassName == "教学类荣誉所属项目"
          );
          this.zdjsxmmc = res.Data.filter(
            (x) => x.ClassName == "指导教师项目名称"
          );
          this.zdxsxmmc = res.Data.filter(
            (x) => x.ClassName == "指导学生项目名称"
          );
          this.xxpxxmmc = res.Data.filter(
            (x) => x.ClassName == "学习培训项目名称"
          );
          this.pxhdzt = res.Data.filter((x) => x.ClassName == "培训活动主题");
        }
      });
    },
    conver(data, source) {
      switch (data.ParamType) {
        case "Array":
          if (source.ApiParamValue) {
            var arr = source.ApiParamValue.split(",");
            data.Value1 = arr.map((x) => {
              var num = Number(x);
              if (isNaN(num)) return x;
              else return num;
            });
          } else {
            data.Value1 = [];
          }
          break;
        case "Date":
          if (source.ApiParamValue) {
            data.Value1 = source.ApiParamValue.split(",");
          }
          break;
        case "Bool":
          if (source.ApiParamValue === "" || source.ApiParamValue === null) {
            data.Value1 = null;
          } else data.Value1 = source.ApiParamValue === "true";
          break;
        case "Interval":
          if (source.ApiParamValue) {
            var values = source.ApiParamValue.split(",");
            data.Value1 = values[0];
            data.Value2 = values[1];
          }
          break;
        default:
          if (source.ApiParamValue == "" || source.ApiParamValue == null) {
            data.Value1 = source.ApiParamValue;
          } else {
            var num = Number(source.ApiParamValue);
            if (isNaN(num)) data.Value1 = source.ApiParamValue;
            else data.Value1 = num;
          }
          break;
      }
    },
    showTitle(type) {
      switch (type) {
        case "基本信息":
          return this.Titles.indexOf("BaseInfo") != -1;
          break;
        case "育人工作":
          var Theme = this.Titles.indexOf("Theme") != -1;
          var EduHoner = this.Titles.indexOf("EduHoner") != -1;
          var EduAward = this.Titles.indexOf("EduAward") != -1;
          var ClassAward = this.Titles.indexOf("ClassAward") != -1;
          return Theme || EduHoner || EduAward || ClassAward;
          break;
        case "课程教学":
          var OpenClass = this.Titles.indexOf("OpenClass") != -1;
          var Edu1Race = this.Titles.indexOf("Edu1Race") != -1;
          var Edu2Race = this.Titles.indexOf("Edu2Race") != -1;
          var TeachHoner = this.Titles.indexOf("TeachHoner") != -1;
          return OpenClass || Edu1Race || Edu2Race || TeachHoner;
          break;
        case "教科研":
          var Paper = this.Titles.indexOf("Paper") != -1;
          var EduProject = this.Titles.indexOf("EduProject") != -1;
          var Book = this.Titles.indexOf("Book") != -1;
          var EduResult = this.Titles.indexOf("EduResult") != -1;
          return Paper || EduProject || Book || EduResult;
          break;
        case "示范引领":
          var Group = this.Titles.indexOf("Group") != -1;
          var GuideTeacher = this.Titles.indexOf("GuideTeacher") != -1;
          var Lecture = this.Titles.indexOf("Lecture") != -1;
          var ComHoner = this.Titles.indexOf("ComHoner") != -1;
          return Group || GuideTeacher || Lecture || ComHoner;
          break;
        case "指导学生":
          return this.Titles.indexOf("GuideStudent") != -1;
          break;
        case "学习培训":
          return this.Titles.indexOf("Train") != -1;
          break;
      }
    },
    showSubTitle(type) {
      return this.Titles.indexOf(type) != -1;
    },
    setQuery(data, source) {
      switch (source.ParamType) {
        case "Array":
          data[source.ApiParamName] = source.Value1;
          break;
        case "Date":
          if (source.Value1) {
            var params = source.ApiParamName.split(",");
            data[params[0]] = source.Value1[0];
            data[params[1]] = source.Value1[1];
          }
          break;
        case "Interval":
          if (source.Value1) {
            var params = source.ApiParamName.split(",");
            data[params[0]] = source.Value1;
            data[params[1]] = source.Value2;
          }
          break;
        default:
          data[source.ApiParamName] = source.Value1;
          break;
      }
    },
    turnBack(data, source) {
      switch (source.ParamType) {
        case "Array":
          if (source.Value1) data.ApiParamValue = source.Value1.join(",");
          break;
        case "Date":
          if (source.Value1) data.ApiParamValue = source.Value1.join(",");
          break;
        case "Bool":
          if (source.Value1 === "" || source.Value1 === null) {
            data.ApiParamValue = null;
          } else data.ApiParamValue = source.Value1;
          break;
        case "Interval":
          data.ApiParamValue = source.Value1 + "," + source.Value2;
          break;
        default:
          data.ApiParamValue = source.Value1;
          break;
      }
    },
    findComponent(item,name) {
      var arr = item.Dts.filter(x => x.ApiParamName == name);
      return arr.length > 0;
    },
    findSn(item,name) {
      var index = item.Dts.findIndex(x => x.ApiParamName == name);
      return index;
    },
  },
};
</script>
<style lang="scss" scoped>
  .query-row {
    display: flex;
    align-items: center;
    .part {
      width: 60px;
      text-align: center;
      color: #f11;
    }
  }
  .bl {
    border-left:1px solid #ebeef5;
  }
  .br {
    border-right:1px solid #ebeef5;
  }
</style>